import React from "react";
import styled from "styled-components";
import {contentMaxWidth} from "src/core/common/themes/media";
import Header from "src/core/common/components/collections/menu/simple";
import CategoryBar from "src/core/products/components/v2/CategoryBar";
import DeliveryBanner from "src/core/deliveries/components/DeliveryBanner";
import useFeatureToggles from "src/core/common/hooks/useFeatureToggles";
import dynamic from "next/dynamic";
import {logModuleLoadError} from "src/core/common/utils";

export default function ColourfulBasePage({children, ...props}) {
  const toggles = useFeatureToggles();
  return (
    <>
      <Header />
      {!toggles.kioskMode() && <DeliveryBanner />}
      <CategoryBar />
      <Content>{children}</Content>
      <ProductDetailModal {...props} />
    </>
  );
}

const ProductDetailModal = dynamic(
  () =>
    import("src/core/pages/ProductDetail").catch(
      logModuleLoadError("ProductDetail", {critical: true})
    ),
  {
    ssr: true,
  }
);

const Content = styled.div`
  margin: 0 auto;
  max-width: ${contentMaxWidth};
`;
